import AppListing from '../app-components/Listing/AppListing';

Vue.component('document-template-listing', {
    mixins: [AppListing],
    data: function data() {
        return {
            orderBy: {
                column: 'title',
                direction: 'asc'
            },
            filters: {
                'position_id': '',
                'company_contract_type_id': '',
                'document_type_id': '',
                'restaurant_id': '',
            },
            deleteModalConfirmId: null,
            deleteModalConfirmResourceUrl: null,
        };
    },

    computed: {
        documentTemplates() {
            return this.collection
        }
    },

    methods: {
        showModal(id, url) {
            this.deleteModalConfirmId = id;
            this.deleteModalConfirmResourceUrl = url;
            this.$modal.show('delete-document-template-form');
        },

        getFormattedPositionsList(positions) {
            return positions.map(item => item['title']).join('\n');
        },

        getFormattedRestaurantsList(restaurants) {
            return restaurants.map(item => item['title']).join('\n');
        },

        handleDeleteTemplate(id) {
            this.collection = this.collection.filter((item) => item.id !== id)
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-template/Listing.js